// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2qkHd","signatureButtonsRight":"ModalSign_signatureButtonsRight__2Iw_M"};